import { useEffect, useState } from 'react';

/**
 * Bailey the desk pet: whether he is on screen and where he was left.
 *
 * Stored per person in localStorage, so he stays where he was put across
 * pages, reloads and browser tabs. Other tabs hear about changes through the
 * storage event, so hiding him in one tab hides him everywhere.
 */

const EVENT = 'beu:bailey-pet-changed';
const key = () => `beu:bailey-pet:${localStorage.getItem('userId') || 'anon'}`;
const DEFAULTS = { visible: true, x: null, y: null };

export function getPet() {
  try {
    const raw = localStorage.getItem(key());
    return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
  } catch (e) {
    return { ...DEFAULTS };
  }
}

export function setPet(patch) {
  const next = { ...getPet(), ...patch };
  try { localStorage.setItem(key(), JSON.stringify(next)); } catch (e) { /* storage unavailable */ }
  try { window.dispatchEvent(new CustomEvent(EVENT, { detail: next })); } catch (e) { /* ignore */ }
  return next;
}

/** The pet's settings, kept current with this tab and every other one. */
export function usePet() {
  const [pet, set] = useState(getPet);
  useEffect(() => {
    const here = () => set(getPet());
    const elsewhere = (e) => { if (!e.key || e.key === key()) set(getPet()); };
    window.addEventListener(EVENT, here);
    window.addEventListener('storage', elsewhere);
    return () => {
      window.removeEventListener(EVENT, here);
      window.removeEventListener('storage', elsewhere);
    };
  }, []);
  return pet;
}
